import React from 'react';
import { Bell, Heart, Weight, Thermometer, Activity, Droplets, Plus, Trophy, Flame, Timer, Zap, BookOpen, Dumbbell } from 'lucide-react';
export function Dashboard() {
  return <div className="p-8 max-w-7xl mx-auto space-y-8" data-id="element-36">
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-37">
        <div data-id="element-38">
          <h1 className="text-3xl font-bold text-slate-900" data-id="element-39">Good Morning,</h1>
          <p className="text-slate-500 mt-1 flex items-center gap-2" data-id="element-40">
            Oto <span className="text-xl" data-id="element-41">👋</span>
          </p>
        </div>
        <button className="p-3 bg-white rounded-full border border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-blue-600 transition-colors relative" data-id="element-42">
          <Bell className="w-5 h-5" data-id="element-43" />
          <span className="absolute top-3 right-3 w-2 h-2 bg-red-500 rounded-full border-2 border-white" data-id="element-44"></span>
        </button>
      </div>

      {/* Metrics Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-45">
        {/* Heart Rate - Primary Card */}
        <div className="bg-blue-600 rounded-2xl p-6 text-white shadow-lg shadow-blue-200 relative overflow-hidden group" data-id="element-46">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full -mr-10 -mt-10 transition-transform group-hover:scale-110" data-id="element-47"></div>
          <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center mb-4 backdrop-blur-sm" data-id="element-48">
            <Heart className="w-5 h-5 text-white fill-white" data-id="element-49" />
          </div>
          <p className="text-blue-100 text-sm font-medium" data-id="element-50">Heart Rate</p>
          <div className="flex items-end gap-2 mt-1" data-id="element-51">
            <h3 className="text-3xl font-bold" data-id="element-52">98</h3>
            <span className="text-blue-200 mb-1" data-id="element-53">BPM</span>
          </div>
          <div className="mt-4 h-1 w-full bg-blue-800/30 rounded-full overflow-hidden" data-id="element-54">
            <div className="h-full bg-white w-2/3 rounded-full" data-id="element-55"></div>
          </div>
        </div>

        {/* Weight */}
        <div className="bg-blue-100 rounded-2xl p-6 text-blue-900 relative overflow-hidden hover:shadow-md transition-shadow" data-id="element-56">
          <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center mb-4 shadow-sm" data-id="element-57">
            <Weight className="w-5 h-5 text-blue-600" data-id="element-58" />
          </div>
          <p className="text-blue-600 text-sm font-medium" data-id="element-59">Weight</p>
          <div className="flex items-end gap-2 mt-1" data-id="element-60">
            <h3 className="text-3xl font-bold" data-id="element-61">72</h3>
            <span className="text-blue-500 mb-1" data-id="element-62">kg</span>
          </div>
          <div className="mt-4 h-1 w-full bg-blue-200 rounded-full overflow-hidden" data-id="element-63">
            <div className="h-full bg-blue-600 w-3/4 rounded-full" data-id="element-64"></div>
          </div>
        </div>

        {/* Temperature */}
        <div className="bg-slate-100 rounded-2xl p-6 text-slate-900 relative overflow-hidden hover:shadow-md transition-shadow" data-id="element-65">
          <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center mb-4 shadow-sm" data-id="element-66">
            <Thermometer className="w-5 h-5 text-slate-600" data-id="element-67" />
          </div>
          <p className="text-slate-500 text-sm font-medium" data-id="element-68">Temperature</p>
          <div className="flex items-end gap-2 mt-1" data-id="element-69">
            <h3 className="text-3xl font-bold" data-id="element-70">36.5</h3>
            <span className="text-slate-400 mb-1" data-id="element-71">°C</span>
          </div>
          <div className="mt-4 h-1 w-full bg-slate-200 rounded-full overflow-hidden" data-id="element-72">
            <div className="h-full bg-slate-600 w-1/2 rounded-full" data-id="element-73"></div>
          </div>
        </div>

        {/* Blood Sugar */}
        <div className="bg-white border border-slate-100 rounded-2xl p-6 text-slate-900 relative overflow-hidden hover:shadow-md transition-shadow" data-id="element-74">
          <div className="w-10 h-10 bg-slate-50 rounded-xl flex items-center justify-center mb-4" data-id="element-75">
            <Activity className="w-5 h-5 text-slate-600" data-id="element-76" />
          </div>
          <p className="text-slate-500 text-sm font-medium" data-id="element-77">Blood Sugar</p>
          <div className="flex items-end gap-2 mt-1" data-id="element-78">
            <h3 className="text-3xl font-bold" data-id="element-79">80</h3>
            <span className="text-slate-400 mb-1" data-id="element-80">mg/dL</span>
          </div>
          <div className="mt-4 h-1 w-full bg-slate-100 rounded-full overflow-hidden" data-id="element-81">
            <div className="h-full bg-slate-800 w-1/3 rounded-full" data-id="element-82"></div>
          </div>
        </div>
      </div>

      {/* Middle Section: Water & Workout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-83">
        {/* Water Intake */}
        <div className="bg-blue-600 rounded-2xl p-8 text-white shadow-lg shadow-blue-200 flex flex-col justify-between relative overflow-hidden" data-id="element-84">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -mr-20 -mt-20" data-id="element-85"></div>

          <div className="flex justify-between items-start z-10" data-id="element-86">
            <div className="flex items-center gap-2" data-id="element-87">
              <Droplets className="w-5 h-5 text-blue-200" data-id="element-88" />
              <h3 className="font-semibold text-lg" data-id="element-89">Water Intake</h3>
            </div>
            <button className="p-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors" data-id="element-90">
              <Plus className="w-4 h-4" data-id="element-91" />
            </button>
          </div>

          <div className="flex items-center gap-8 my-6 z-10" data-id="element-92">
            <div className="relative w-32 h-32 flex-shrink-0" data-id="element-93">
              <svg className="w-full h-full transform -rotate-90" data-id="element-94">
                <circle cx="64" cy="64" r="56" stroke="currentColor" strokeWidth="12" fill="transparent" className="text-blue-800/30" data-id="element-95" />
                <circle cx="64" cy="64" r="56" stroke="currentColor" strokeWidth="12" fill="transparent" strokeDasharray="351.86" strokeDashoffset="351.86" className="text-white" data-id="element-96" />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-97">
                <span className="text-3xl font-bold" data-id="element-98">0%</span>
              </div>
            </div>
            <div data-id="element-99">
              <div className="flex items-baseline gap-1" data-id="element-100">
                <span className="text-4xl font-bold" data-id="element-101">0</span>
                <span className="text-blue-200" data-id="element-102">ml</span>
              </div>
              <p className="text-blue-200 text-sm mt-1" data-id="element-103">0 glasses today</p>
              <p className="text-blue-200 text-xs" data-id="element-104">2000ml to go</p>
            </div>
          </div>

          <div className="grid grid-cols-4 gap-3 z-10" data-id="element-105">
            {[150, 250, 350, 500].map(amount => <button key={amount} className="py-2 px-1 bg-white/10 hover:bg-white/20 rounded-lg text-xs font-medium transition-colors" data-id="element-106">
                +{amount}ml
              </button>)}
          </div>
        </div>

        {/* This Week Stats */}
        <div className="bg-slate-800 rounded-2xl p-8 text-white shadow-lg relative overflow-hidden" data-id="element-107">
          <div className="flex justify-between items-center mb-8" data-id="element-108">
            <div className="flex items-center gap-2" data-id="element-109">
              <Activity className="w-5 h-5 text-emerald-400" data-id="element-110" />
              <h3 className="font-semibold text-lg" data-id="element-111">This Week</h3>
            </div>
            <button className="text-xs font-medium text-slate-400 hover:text-white flex items-center gap-1" data-id="element-112">
              View all <Plus className="w-3 h-3" data-id="element-113" />
            </button>
          </div>

          <div className="grid grid-cols-3 gap-4" data-id="element-114">
            <div className="bg-slate-700/50 rounded-xl p-4 text-center hover:bg-slate-700 transition-colors" data-id="element-115">
              <div className="w-8 h-8 bg-slate-600 rounded-lg flex items-center justify-center mx-auto mb-3" data-id="element-116">
                <Zap className="w-4 h-4 text-yellow-400" data-id="element-117" />
              </div>
              <p className="text-2xl font-bold" data-id="element-118">3</p>
              <p className="text-xs text-slate-400 mt-1" data-id="element-119">Workouts</p>
            </div>
            <div className="bg-slate-700/50 rounded-xl p-4 text-center hover:bg-slate-700 transition-colors" data-id="element-120">
              <div className="w-8 h-8 bg-slate-600 rounded-lg flex items-center justify-center mx-auto mb-3" data-id="element-121">
                <Timer className="w-4 h-4 text-blue-400" data-id="element-122" />
              </div>
              <p className="text-2xl font-bold" data-id="element-123">120</p>
              <p className="text-xs text-slate-400 mt-1" data-id="element-124">Minutes</p>
            </div>
            <div className="bg-slate-700/50 rounded-xl p-4 text-center hover:bg-slate-700 transition-colors" data-id="element-125">
              <div className="w-8 h-8 bg-slate-600 rounded-lg flex items-center justify-center mx-auto mb-3" data-id="element-126">
                <Flame className="w-4 h-4 text-orange-400" data-id="element-127" />
              </div>
              <p className="text-2xl font-bold" data-id="element-128">850</p>
              <p className="text-xs text-slate-400 mt-1" data-id="element-129">Calories</p>
            </div>
          </div>
        </div>
      </div>

      {/* Achievements */}
      <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm" data-id="element-130">
        <div className="flex items-center gap-2 mb-6" data-id="element-131">
          <Trophy className="w-5 h-5 text-yellow-500" data-id="element-132" />
          <h3 className="font-bold text-lg text-slate-900" data-id="element-133">Achievements</h3>
          <span className="ml-auto text-sm text-slate-500" data-id="element-134">2 earned</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-135">
          <div className="bg-slate-50 rounded-xl p-6 text-center" data-id="element-136">
            <Droplets className="w-8 h-8 text-blue-500 mx-auto mb-3" data-id="element-137" />
            <p className="text-2xl font-bold text-slate-900" data-id="element-138">5</p>
            <p className="text-xs text-slate-500" data-id="element-139">Water streak</p>
          </div>
          <div className="bg-slate-50 rounded-xl p-6 text-center" data-id="element-140">
            <Flame className="w-8 h-8 text-orange-500 mx-auto mb-3" data-id="element-141" />
            <p className="text-2xl font-bold text-slate-900" data-id="element-142">3</p>
            <p className="text-xs text-slate-500" data-id="element-143">Exercise streak</p>
          </div>
          <div className="bg-slate-50 rounded-xl p-6 text-center" data-id="element-144">
            <BookOpen className="w-8 h-8 text-purple-500 mx-auto mb-3" data-id="element-145" />
            <p className="text-2xl font-bold text-slate-900" data-id="element-146">12</p>
            <p className="text-xs text-slate-500" data-id="element-147">Journal streak</p>
          </div>
        </div>

        <div className="space-y-6" data-id="element-148">
          <div data-id="element-149">
            <div className="flex justify-between text-sm mb-2" data-id="element-150">
              <span className="font-medium text-slate-700 flex items-center gap-2" data-id="element-151">
                <Dumbbell className="w-4 h-4 text-slate-400" data-id="element-152" /> Workout Warrior
              </span>
              <span className="text-slate-400" data-id="element-153">4/10</span>
            </div>
            <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden" data-id="element-154">
              <div className="h-full bg-slate-800 w-2/5 rounded-full" data-id="element-155"></div>
            </div>
          </div>
          <div data-id="element-156">
            <div className="flex justify-between text-sm mb-2" data-id="element-157">
              <span className="font-medium text-slate-700 flex items-center gap-2" data-id="element-158">
                <BookOpen className="w-4 h-4 text-slate-400" data-id="element-159" /> Mindful Logger
              </span>
              <span className="text-slate-400" data-id="element-160">2/7</span>
            </div>
            <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden" data-id="element-161">
              <div className="h-full bg-slate-800 w-2/7 rounded-full" data-id="element-162"></div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}